import { postData } from "./apis";

export const updateLockStatus = async (
    id: string,
    lockStatus: "lock" | "unlock"
  ) => {
    try {
      await postData({
        endPoint: "updateDocumentLockStatus",
        data: {
          documentId: id,
          updateType: lockStatus,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };